import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";

//----- store
import { fetchApiConfigData } from "./store/apiConfig-actions";
import { uiActions } from "./store/ui-slice";
import { getNewToken, refreshToken } from "./store/ui-actions";

import Layout from "./components/Layout/Layout";
import Dashboard from "./pages/Dashboard";
import MyCourses from "./pages/MyCourses";
import CourseDetails from "./pages/CourseDetails";
import ActionDetails from "./pages/ActionDetails";
import CourseCompletedDetails from "./pages/CourseCompletedDetails";
import CatalogDetails from "./pages/CatalogDetails";
import MyCalendar from "./pages/MyCalendar";
import CoursesCatalog from "./pages/CoursesCatalog";
import NotFound from "./pages/NotFound";

import "./App.css";

const url = window.location.href;
const domain = url.split(/[/?#]/)[0];
// const apiConfig_url = `${domain}/config/apiConfig.json`;
const apiConfig_url = "./config/apiConfig.json";  // tentar esta path sem a / inicial "config/apiConfig.json"

let tokenTimer = null;

function App(props) {
	const dispatch = useDispatch();
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const [apiConfigLoaded, setApiConfigLoaded] = useState(false);
	const apiConfigData = useSelector((state) => state.apiConfigData);

	const harmonize_url =
		apiConfigData.endpoint.domain + apiConfigData.endpoint.harmonizeToken;
	
	const refreshToken_url = apiConfigData.endpoint.domain + apiConfigData.endpoint.refreshToken;
	
	const setTokenRefresh = () => {
		if (tokenTimer) {
			console.log("clear tokenTimer")
			clearInterval(tokenTimer);
		}

		tokenTimer = setInterval(function () {
			console.log("refreshToken");
			dispatch(refreshToken(refreshToken_url, autenticationData));
		}, 300000); // colocar de 5 em 5 minutos
		// }, 60000); // colocar de 1 em 1 minuto
	};

	useEffect(() => {
		// console.log("useEffect 1 COOKIE TOKEN", props.token);
		if (autenticationData.cookieToken !== "") {
			// console.log("COOKIE TOKEN IN STORE")
			// console.log("autenticationData", autenticationData)
		} else {
			// console.log("NO COOKIE TOKEN IN STORE")
			dispatch(uiActions.updateCookieToken(props.token));
		}
	}, [dispatch]);

	useEffect(() => {
		if (autenticationData.cookieToken !== "") {
			// console.log("useEffect 2 COOKIE TOKEN IN STORE")
			if (autenticationData.token !== "") {
				console.log("useEffect 2 TOKEN IN STORE", autenticationData);
				setApiConfigLoaded(true);
				setTokenRefresh();
			} else {
				// console.log("useEffect 2 NO TOKEN IN STORE")
				dispatch(
					fetchApiConfigData(apiConfig_url, {
						...autenticationData,
						token: autenticationData.cookieToken,
					})
				);
			}
		} else {
			// console.log("useEffect 2 NO COOKIE TOKEN IN STORE")
		}
	}, [autenticationData]);

	useEffect(() => {
		if (apiConfigData.endpoint.harmonizeToken !== "") {
			// console.log("useEffect 3 API CONFIG DATA LOADED", apiConfigData);
			dispatch(getNewToken(harmonize_url, autenticationData.cookieToken));
		} else {
			// console.log("useEffect 3 API CONFIG DATA NOT LOADED", apiConfigData);
		}
	}, [apiConfigData]);

	return (
		<div className="App">
			{/* <div style={{position: "absolute", background: "linear-gradient(87deg,#FB6340,#FBB140)", width: "100%", height: "440px"}}></div> */}
			{apiConfigLoaded && (
				<Layout userId={props.userId}>
					<Switch>
						<Route path="/" exact>
							{/* <Redirect to="/formacao" /> */}
						</Route>
						<Route path="/formacao" exact>
							<Dashboard />
						</Route>
						<Route path="/formacao/courses" exact>
							<Redirect to="/formacao/courses/enrolled" />
						</Route>
						<Route path="/formacao/courses/requests" exact>
							<MyCourses />
						</Route>
						<Route path="/formacao/courses/enrolled" exact>
							<MyCourses />
						</Route>
						<Route path="/formacao/courses/completed" exact>
							<MyCourses />
						</Route>
						<Route path="/formacao/courses/details/:courseId" exact>
							<CourseDetails />
						</Route>
						<Route
							path="/formacao/courses/actions/details/:actionId"
							exact
						>
							<ActionDetails />
						</Route>
						<Route
							path="/formacao/courses/completed/details/:trainingType/:courseId"
							exact
						>
							<CourseCompletedDetails />
						</Route>
						<Route path="/formacao/calendar" exact>
							<MyCalendar />
						</Route>
						<Route path="/formacao/catalog" exact>
							<CoursesCatalog />
						</Route>
						<Route path="/formacao/catalog/details/:courseId" exact>
							<CatalogDetails />
						</Route>
						<Route path="*">
							<NotFound />
						</Route>
					</Switch>
				</Layout>
			)}
		</div>
	);
}

export default App;
